import React from 'react';
import { useHistory } from 'react-router-dom'

const SearchItem = ({item}) => {
    const history = useHistory()
    return (
        <>
        {item.images[0] && <div className="search__result-item" onClick={() => history.push(`/playlist/${item.id}`)}>
           <img src={`${item.images[0].url}`} />
           <div className="search__text">
               <h3>{item.name}</h3>
               <p>{item.description}</p>
           </div>
        </div>}
        </>
    );
}

export default SearchItem;
